export const formatPhoneForDisplay = (phone: string | undefined) => {
	if (!phone) {
		return ''
	}
	const phoneWithOnlyNumbers = phone.replace(/\D/g, '').slice(-10)

	return `(${phoneWithOnlyNumbers?.slice(0, 3)}) ${phoneWithOnlyNumbers?.slice(3, 6)}-${phoneWithOnlyNumbers?.slice(6)}`
}

export const trimPhone = (phone: string) => { // Remove all non-numeric characters from phone number
	return phone.replace(/\D/g, '')
}

export const formatPhoneNumber = (value: string) => {
	// Remove all non-digits (including any +1 country code)
	const cleaned = value.replace(/\D/g, '')

	// Remove leading 1 if it's 11 digits (US country code)
	const digitsOnly = cleaned.length === 11 && cleaned.startsWith('1')
		? cleaned.slice(1)
		: cleaned

	// Limit to 10 digits
	const limited = digitsOnly.slice(0, 10)

	// Format based on length
	if (limited.length === 0) {
		return ''
	} else if (limited.length <= 3) {
		return `(${limited}`
	} else if (limited.length <= 6) {
		return `(${limited.slice(0, 3)}) ${limited.slice(3)}`
	} else {
		return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`
	}
}

export const unformatPhoneNumber = (value: string) => {
	// Remove all non-digits
	const cleaned = value.replace(/\D/g, '')

	// Remove leading 1 if it's 11 digits
	if (cleaned.length === 11 && cleaned.startsWith('1')) {
		return cleaned.slice(1)
	}

	return cleaned
}

export const parsePhoneNumber = (value: string) => {
	// Extract just the digits
	const digitsOnly = value.replace(/\D/g, '')

	// Remove country code if present (1 at the start of 11 digits)
	const phoneDigits = digitsOnly.length === 11 && digitsOnly.startsWith('1')
		? digitsOnly.slice(1)
		: digitsOnly

	return {
		digits: phoneDigits.slice(0, 10), // Ensure max 10 digits
		isValid: phoneDigits.length === 10
	}
}

export default {
	formatPhoneForDisplay,
	trimPhone,
	formatPhoneNumber,
	unformatPhoneNumber,
	parsePhoneNumber
}
